module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/appModalCrumbsView.html -->\n<ul class="nx-childviews"></ul>';
}
return __p;
};
